import React from 'react'
import Glogo from './Images/Glogo.png'
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

export default function Footer() {
  return (
    <div className="w-100">
  <footer className="border-top w-full" style={{ backgroundColor: "#ADE4DB" }}>
    <div className="container py-5" style={{ maxWidth: "960px" }}>
      <div className="row text-black">
        <div className="col-md-4">
          <h3 style={{color:"#54B435", fontFamily: "Arial Black", fontSize: "24px" }}>
          <img src={Glogo} alt='' style={{width:"35px", height:"31px", left:"4px", position:"relative"}}/>
          oFoodie</h3>
          
          <p className="text-secondary mt-3" style={{ fontFamily: "Verdana", fontSize: "14px" }}>
            Retail food delivery is a courier service in which a restaurant, store, or independent food delivery.
          </p>
          <div className="social-icons mt-3">
            <FacebookIcon className="mr-2" style={{ fontSize: "24px", color: "#54B435" }} />
            <TwitterIcon className="mr-2" style={{ fontSize: "24px", color: "#54B435" }} />
            <LinkedInIcon style={{ fontSize: "24px", color: "#54B435" }} />
          </div>
        </div>
        <div className="col-md-4 ">
          <h5 style={{ fontFamily: "Arial Black", fontSize: "18px" }}>Company</h5>
          <div className="text-secondary" style={{ fontFamily: "Verdana", fontSize: "14px" }}>
            <p>About Us</p>
            <p>All Products</p>
            <p>Blog</p>
            <p>Locations Map</p>
          </div>
        </div>
        <div className="col-md-4">
          <h5 style={{ fontFamily: "Arial Black", fontSize: "18px" }}>Support/Contact</h5>
          <div className="text-secondary" style={{ fontFamily: "Verdana", fontSize: "14px" }}>
            <p>Policy</p>
            <p>Support Center</p>
            <p>WhatsApp</p>
            <p>Quick Chat</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <div className="d-flex align-items-center justify-content-center bg-success py-3">
    <p style={{ fontFamily: "Arial Black", fontSize: "14px", color: "#fff" }}>© 2023 GoFoodie, Inc</p>
  </div>
</div>
  )
}